import type { FeatureCollection, Geometry, GeoJsonProperties } from 'geojson';

export const SIZE_SOFT_LIMIT = 4_500_000;
export const TOLERANCE_STEPS = [0.00002, 0.00005, 0.0001] as const;
export const HIGH_QUALITY = false;
export const ADD_CHUNK_SIZE = 250;
export const INTERSECTION_AREA_EPS = 1e-8;
export const CIRCLE_STEPS = 64;
export const MAX_CIRCLE_HA = 4;
export const MIN_CIRCLE_HA = 0.01;
export const HEAVY_FEATURE_LIMIT = 200;
export const HEAVY_VERTEX_LIMIT = 12000;

export const EMPTY_FC: FeatureCollection<Geometry, GeoJsonProperties> = {
  type: 'FeatureCollection',
  features: [],
};
